import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bookingService } from "./booking.services";
import { BOOKING_KEYS } from "./keys";

// Hook to manually refresh all booking data - useful for hard refresh
export const useRefreshBookingData = () => {
  const qc = useQueryClient();

  return () => {
    // Invalidate all booking-related queries to force refetch
    qc.invalidateQueries({
      queryKey: [BOOKING_KEYS.BOOKINGS],
    });
    qc.invalidateQueries({
      queryKey: [BOOKING_KEYS.BOOKING],
    });
  };
};

export const useCreateBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bookingService.createBooking,
    onSuccess: () => {
      // Invalidate all booking-related queries
      qc.invalidateQueries({
        queryKey: [BOOKING_KEYS.BOOKINGS],
      });
    },
  });
};

export const useCreateQuickEstimate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bookingService.createQuickEstimate,
    onSuccess: () => {
      // Invalidate all booking-related queries
      qc.invalidateQueries({
        queryKey: [BOOKING_KEYS.BOOKINGS],
      });
    },
  });
};

export const useUpdateBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bookingService.updateBooking,
    onSuccess: (data, variables) => {
      // Invalidate specific booking and all booking lists
      qc.invalidateQueries({
        queryKey: [BOOKING_KEYS.BOOKINGS],
      });
      qc.invalidateQueries({
        queryKey: BOOKING_KEYS.GET_BOOKING(variables.id),
      });
    },
  });
};

export const useCopyBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bookingService.copyBooking,
    onSuccess: () => {
      // Invalidate all booking lists since a new booking was created
      qc.invalidateQueries({
        queryKey: [BOOKING_KEYS.BOOKINGS],
      });
    },
  });
};

export const useDeleteBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: bookingService.deleteBooking,
    onSuccess: (data, variables) => {
      // Remove specific booking from cache and invalidate all booking lists
      qc.removeQueries({
        queryKey: BOOKING_KEYS.GET_BOOKING(variables),
      });
      qc.invalidateQueries({
        queryKey: [BOOKING_KEYS.BOOKINGS],
      });
    },
  });
};
